<template>
  <div class="pa-4 text-center">
    <v-dialog v-model="dialog" max-width="600">
      <template v-slot:activator="{ props: activatorProps }">
        <v-btn
          v-auth-click="{
            roles: ['simple-user', 'licence-manager'],
            message: 'Sie haben keine Berechtigung, Nutzer einzuladen!',
          }"
          class="text-none font-weight-regular"
          prepend-icon="mdi-account"
          text="User einladen"
          variant="tonal"
          v-bind="activatorProps"
        ></v-btn>
      </template>
      <v-card prepend-icon="mdi-account" title="User zu Projekten einladen">
        <v-card-text>
          <v-row dense>
            <v-col cols="12" md="4" sm="6">
              <v-text-field
                v-model="username"
                :rules="nameRules"
                label="Benutzername*"
                hint="Benutzername, der bei der Anmeldung erforderlich ist"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" sm="6">
              <v-text-field
                v-model="password"
                type="password"
                label="temporäres Passwort*"
                hint="temporäres Passwort wird bei der Erstanmeldung vom Nutzer geändert"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" sm="6">
              <v-text-field v-model="firstName" label="Vorname"></v-text-field>
            </v-col>

            <v-col cols="12" md="4" sm="6">
              <v-text-field v-model="lastName" label="Nachname"></v-text-field>
            </v-col>

            <v-col cols="12" md="4" sm="6">
              <v-text-field
                v-model="email"
                type="email"
                placeholder="johndoe@web.de"
                label="Email*"
                :rules="emailRules"
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4" sm="6"> </v-col>
            <v-col cols="12" sm="6">
              <v-select
                v-model="selectedProjectIds"
                :items="projects"
                :item-title="'name'"
                :multiple="true"
                :item-value="'id'"
                :error-messages="projectsError"
                label="Projekt"
                id="test"
              ></v-select>
            </v-col>
          </v-row>

          <small class="text-caption text-medium-emphasis"
            >*Pflichtfelder</small
          >
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn text="Close" variant="plain" @click="dialog = false"></v-btn>

          <v-btn
            color="primary"
            text="invite user"
            variant="tonal"
            @click="save()"
          ></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script lang="ts">
import { UserProjectRelation } from "@/api";
import { mapStores } from "pinia";
import { toRaw } from "vue";
import { useOfficeStore } from "../store/officeStore";

export default {
  data: () => ({
    dialog: false,
    selectedProjectIds: [],
    username: "",
    firstName: "",
    lastName: "",
    password: "",
    email: "",
    projectsError: "",
    nameRules: [
      (v) => !!v || "Benutzername ist notwendig!",
      (v) =>
        v.length <= 30 || "Benutzername muss weniger als 30 Buchstaben haben",
      (v) => !/\s/.test(v) || "Benutzername darf keine Leerzeichen enthalten",
    ],
    emailRules: [
      (v) =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "E-mail is ungültig",
    ],
  }),
  computed: {
    ...mapStores(useOfficeStore),
    projects() {
      // @ts-ignore
      return this.officeStore.getProjects;
    },
    selectedProject() {
      let selected = this.projects.find((val: any) => {
        if (val.id) {
          if (val.id === this.selectedProjectIds) {
            return true;
          }
        }
        return false;
      });
      if (!selected) {
        return { name: null, id: null };
      }
      return selected;
    },
  },
  methods: {
    clearFields() {
      this.selectedProjectIds = [];
      this.username = "";
      this.firstName = "";
      this.lastName = "";
      this.password = "";
      this.email = "";
    },
    save() {
      const officeStore = useOfficeStore();

      const user: UserProjectRelation = {
        email: this.email,
        password: this.password,
        firstName: this.firstName,
        lastName: this.lastName,
        projectIds: toRaw(this.selectedProjectIds),
        username: this.username,
        userRole: UserProjectRelation.UserRoleEnum.SimpleUser,
      };
      officeStore.addUserToProject(user); //.then(val => );
      this.dialog = false;
      this.clearFields();
    },
  },
};
</script>
